
























import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    components: {
        HTMLContent
    },
    setup(props) {
        const hasDescription = (props.product.description && props.product.description.html) || (props.product.shortDescription && props.product.shortDescription.html)
        const description = (props.product.description && props.product.description.html) ? props.product.description.html : props.product.shortDescription?.html
        return {
            hasDescription,
            description
        }
    }
})
